"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FIELD_HISTORY_IMPORT_EMPLOYEE_COUNT_FIELD () {
        return FIELD_HISTORY_IMPORT_EMPLOYEE_COUNT_FIELD;
    },
    get SeededEmployeeCount () {
        return SeededEmployeeCount;
    }
});
const _zod = require("zod");
const _constants = require("./constants");
const FIELD_HISTORY_IMPORT_EMPLOYEE_COUNT_FIELD = "employeeCount";
const SeededEmployeeCount = _zod.z.coerce.number().int().nonnegative().catch(0).transform((count)=>Math.min(count, _constants.MAX_FIELD_HISTORY_IMPORT_ROWS));
